import {
  trackingGroupPeopleFeed,
  trackingGroupLeaveResponse,
  trackingSearchResponse,
  trackingProfileResponse,
  trackingGroupGetStartedFeed,
} from './handlers';

export const ResponseTracker = (operation: any, response: any) => {
  switch (operation.operationName) {
    case 'getProfileHero':
      trackingProfileResponse(operation, response);
      break;

    case 'getSearchFeed':
      trackingSearchResponse(operation, response);
      break;

    case 'getGroupGetStartedFeed':
      trackingGroupGetStartedFeed(operation);
      break;

    case 'getGroupPeopleFeed':
      trackingGroupPeopleFeed(operation);
      break;

    case 'leaveGroup':
      trackingGroupLeaveResponse(operation);
      break;

    case 'deleteGroup':
      trackingGroupLeaveResponse(operation);
      break;

    default:
      break;
  }
};
